import { EmailTemplate } from "../../types/features/administration/EmailTemplate";

export const TemplateSimple: EmailTemplate = {
  id: "simple",
  name: "Template simple",
  description: "Structure épurée avec bannière, contenu riche et appel à l'action",
  templateFile: "simple",
  previewImage: "/templates/previews/simple-preview.png",
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/ff8c00/ffffff?text=BANNIERE",
    title: "Information importante",
    message:
      "Bonjour <strong>{{user_first_name}}</strong>,<br><br>Nous vous informons que <strong style='color:#1a2a3a;'>votre compte a été mis à jour</strong>. Vous pouvez désormais profiter de nos nouveaux services.<br><br>Pour plus de détails, <a href='https://izilifepay.com' style='color:#ff8c00; text-decoration:underline;'>cliquez ici</a>.<br><br>Cordialement,<br>L'équipe IZI LIFE PAY",
    ctaText: "Accéder à mon compte",
    ctaUrl: "https://izilifepay.com/compte",
  },
  fields: [
    {
      name: "heroImage",
      label: "Bannière",
      type: "image",
      required: false,
    },
    {
      name: "title",
      label: "Titre",
      type: "text",
      required: true,
      placeholder: "Ex: Information importante",
      defaultValue: "Information importante",
    },
    {
      name: "message",
      label: "Corps du message",
      type: "textarea",
      required: true,
      placeholder: "Rédigez votre message ici... (HTML autorisé : gras, liens, couleurs)",
    },
    {
      name: "ctaText",
      label: "Texte du bouton",
      type: "text",
      required: false,
      placeholder: "Ex: En savoir plus",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton",
      type: "url",
      required: false,
      placeholder: "https://...",
    },
  ],
};
